import templatePreviewLoader from '../../../../templates/helpers/template-preview-loader';
import {templateModelReducer} from '../../../helpers/template-model-reducer';

export default class CreateTemplateModalController {
    constructor($uibModalInstance, $scope, $injector) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.acl = this.injector.get('Acl');
        this.usersStore = this.injector.get('Users');

        this.shareInsteadOfCopy = false;
        this.currentAddType = 'existing';

        this.templatePreviewImageUrl = '/images/landingpage.png';
        this.currentSelectedTemplate = null;

        this.templateIdToCopy = null;

        this.templateSelectizeOptions = {
            maxItems: 1,
            valueField: 'id',
            searchField: 'name',
            sortField: 'sort',
            render: {
                option: function (data, escape) {
                    let out = '<div class="option">';

                    if (data.global_template) {
                        out += '<i class="fal fa-link"></i>&nbsp;'
                    }

                    out += escape(data.name) + '</div>';

                    return out;
                },
                item: function (data, escape) {
                    let out = '<div class="item">';

                    if (data.global_template) {
                        out += '<i class="fal fa-link"></i>&nbsp;'
                    }

                    out += escape(data.name) + '</div>';

                    return out;
                }
            }
        }
        this.templatesForSelectize = [];

        this.newTemplateModel = {
            name: 'New template',
            subject: 'New template',
            sender_name: _.get(this.usersStore.state, 'company.settings.templates.default_mail_sender_name'),
            email: _.get(this.usersStore.state, 'company.settings.templates.default_mail_sender_address'),
            global_template: true
        };

        this.validForSubmit = false;
        this.submitting = false;
        this._loadTemplatesForSelection();
    }

    $onInit() {
        this._initWatchers();
    }

    createTemplate() {

        this.submitting = true;
        if (this.currentAddType === 'existing') {
            this.api.get(`templates/${this.templateIdToCopy}`).then(({data}) => {
                this.api
                    .post('templates', {
                        ...templateModelReducer(data.data),
                        name: 'Copy: ' + data.data.name
                    })
                    .then(({data}) => {
                        this.uibModalInstance.close({
                            template: data.data
                        })
                    })
                    .catch((e) => {
                        this.alert.handle(e);
                    })
            })
            return;
        }

        if (this.currentAddType === 'new') {
            this.api
                .post('templates/default-content', this.newTemplateModel)
                .then(({data}) => {
                    this.uibModalInstance.close({
                        template: data.data
                    })
                })
                .catch((e) => {
                    this.alert.handle(e);
                })
        }
    }

    handleTemplateSelection() {
        this.currentSelectedTemplate = _.first(_.filter(this.templatesForSelectize, (row) => {
            return row.id === parseInt(this.templateIdToCopy);
        }));

        this._prepareTemplatePreviewImage();
    }

    dismissModal() {
        this.uibModalInstance.dismiss();
    }

    _checkValidForSubmit() {
        if (this.currentAddType === 'new') {
            return !!this.newTemplateModel.subject && !!this.newTemplateModel.name;
        } else if (this.currentAddType === 'existing') {
            return !!this.templateIdToCopy
        }

        return false;
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.currentAddType;
        }, () => {
            this.validForSubmit = this._checkValidForSubmit();
        }, true);

        this.scope.$watch(() => {
            return this.templateIdToCopy;
        }, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.validForSubmit = this._checkValidForSubmit();
                this.handleTemplateSelection();
            }
        }, true);

        this.scope.$watch(() => {
            return this.newTemplateModel;
        }, () => {
            this.validForSubmit = this._checkValidForSubmit();
        }, true)
    }

    _prepareTemplatePreviewImage() {
        if (!this.currentSelectedTemplate) {
            this.templatePreviewImageUrl = '/images/landingpage.png';
            return;
        }

        templatePreviewLoader(this.injector, this.currentSelectedTemplate.id)
            .then((dataUrl) => {
                this.templatePreviewImageUrl = dataUrl;
            })
            .catch(() => {
            });
    }

    _loadTemplatesForSelection() {
        const store = this.injector.get('Templates').reset({
            listview: 'AddTemplateModalTemplatesListView',
            persist: false,
            onlyScoped: false,
            onlyGlobal: false,
            scopedGuestlists: [],
            columns: [
                {
                    key: 'id',
                    type: 'integer',
                    visible: true
                },
                {
                    key: 'name',
                    type: 'string',
                    visible: true
                },
                {
                    key: 'global_template',
                    type: 'boolean',
                    visible: true
                }
            ]
        });

        store.dispatch('getData').then(() => {
            this.templatesForSelectize = _.map(
                store.state.data.sort(
                    (a, b) => {
                        if (a.global_template !== b.global_template) {
                            return !a.global_template ? 1 : -1;
                        }

                        return ('' + a.name).localeCompare(b.name)
                    }
                ),
                (value, key) => {
                    return {
                        ...value,
                        sort: key
                    }
                }
            );

            this.templateIdToCopy = _.get(_.first(this.templatesForSelectize), 'id', null);
        })
    }
}

CreateTemplateModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/controllers/workflows/list/create-template-model-controller.js